import { FC, useState } from "react";

import { Icon } from "../Icon/Icon";
import "./SplitSelect.css";

type Props = {
  click: (addState: boolean) => void;
  defaultAddState?: boolean;
  onChange?: (addState: boolean) => void;
  disabled?: boolean;
  disableAddOnly?: boolean;
};

export const SplitSelect: FC<Props> = ({
  click,
  defaultAddState = true,
  onChange,
  disabled = false,
  disableAddOnly = false,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [addState, setAddState] = useState(defaultAddState);

  return (
    <div className="SplitSelect">
      <div
        className={`SplitSelect__label ${disabled || (disableAddOnly && addState) ? 'SplitSelect__label--disabled' : 'u-cursor-pointer'}`}
        onClick={() => {
          if (disabled) return;
          if (disableAddOnly && addState) return;
          click(addState);
        }}
      >
        <div className="SplitSelect__label-text u-cursor-pointer">
          {" "}
          {addState ? "Tilføj til lager" : "Undlad fra lager"}
        </div>
      </div>
      <div
        className={`SplitSelect__arrow ${disabled ? 'SplitSelect__arrow--disabled' : 'u-cursor-pointer'}`}
        onClick={() => !disabled && setExpanded(!expanded)}
      >
        <Icon name="arrowDown" width={11} className="Icon__arrow-center" />
      </div>
      {expanded && !disabled && (
        <div className="SplitSelect__options">
          <div
            className="SplitSelect__option  u-cursor-pointer"
            onClick={() => {
              setAddState(!addState);
              setExpanded(!expanded);
              onChange && onChange(!addState);
            }}
          >
            {addState ? "Undlad fra lager" : "Tilføj til lager"}
          </div>
        </div>
      )}
    </div>
  );
};
